import React, { FC, ReactNode } from 'react'

import { alpha, SxProps, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

import Iconify from '../../components/Iconify/Iconify'
import { ThemeIcon } from '../../components/ThemeIcon'

type EmptyDataPropsType = {
  children?: ReactNode
  sx?: SxProps
  iconProps?: EmptyDataIconPropsType
  newIcon?: boolean
  title?: string | null
  subtitle?: string | null
}

export const EmptyData: FC<EmptyDataPropsType> = ({
  children,
  sx,
  iconProps,
  newIcon = false,
  title,
  subtitle,
}) => {
  const { t } = useTranslation()
  const { spacing } = useTheme()

  return (
    <Box
      display="flex"
      height={'100%'}
      width={'100%'}
      flexDirection="column"
      alignItems="center"
      justifyContent={'center'}
      sx={{ ...sx, textAlign: 'center' }}
      p={3}
    >
      {newIcon ? (
        <EmptyDataIcon {...iconProps} />
      ) : (
        <Box>
          <ThemeIcon name="trades" alt="Trades" style={{ height: spacing(8) }} />
        </Box>
      )}

      {children ? (
        children
      ) : (
        <Box mt={3} textAlign={'center'}>
          <Typography variant={'body1'}>
            {title || t('noActualDataToShowHere', 'No actual data to show here')}
          </Typography>
          <Typography variant={'body2'}>
            {subtitle || t('tryToSelectDifferentFilters', 'Try to select different filters')}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

type EmptyDataIconPropsType = {
  color?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success' // You can expand the color options if needed
  icon?: string
  sx?: SxProps
}

export const EmptyDataIcon: FC<EmptyDataIconPropsType> = ({
  color = 'primary',
  icon = 'material-symbols-light:candlestick-chart-outline-rounded',
  sx,
}) => {
  const { spacing } = useTheme()

  return (
    <Box
      sx={{
        color: (theme) => theme.palette[color].main,
        backgroundImage: (theme) =>
          `linear-gradient(135deg, ${alpha(theme.palette[color].main, 0)} 0%, ${alpha(
            theme.palette[color].main,
            0.24,
          )} 100%)`,

        display: 'flex',
        padding: 1,
        borderRadius: '50%',
        alignItems: 'center',
        width: spacing(8),
        height: spacing(8),
        justifyContent: 'center',
        ...sx,
      }}
    >
      <Iconify
        icon={icon}
        sx={{
          width: spacing(8),
          height: spacing(8),
        }}
      />
    </Box>
  )
}
